import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { EventComponent, EventComponentProps } from 'stream-chat-react';

/**
 * Stream routes type === 'system' through MessageSystem (default: EventComponent),
 * not through Message / CustomMessage.
 */
export const CustomMessageSystem = (props: EventComponentProps) => {
  const { message } = props;
  const navigate = useNavigate();
  const { tab } = useParams();

  if (message.activityType === 'rsvp') {
    const author = message.user;
    const openAuthorProfile = () => {
      if (!author?.id) return;
      navigate(`/home/${tab}/user/${author.id}`);
    };

    return (
      <div
        className="w-full flex justify-center items-center gap-2 py-[6px] cursor-pointer"
        onClick={openAuthorProfile}
        role="button"
        tabIndex={0}
      >
        {author?.image ? (
          <img
            src={author.image}
            alt={author.name || author.id}
            className="w-6 h-6 rounded-full object-cover shrink-0"
          />
        ) : (
          <div className="w-6 h-6 rounded-full bg-gray-300 shrink-0" />
        )}
        <span className="text-[13px]">
          <span className="font-bold text-brand-color-1">
            {author?.name || author?.id}
          </span>
          {' '}
          <span className="font-normal text-brand-light-grey">
            has RSVPed
          </span>
        </span>
      </div>
    );
  }

  return <EventComponent {...props} />;
};
